import MarketplaceCardBuy from './MarketplaceCardBuy';

export default MarketplaceCardBuy;
